import updateOverflowTitle from '../../../../Component/UI/updateOverflowTitle';
import OrderAddressText from '../../../../Component/UI/OrderAddressText';
import { linkedOrderRowLayout, OrderRowLayout } from "../../../../Component/orderRowLayout";
import { sellerGiftSourceOrder } from "../../../../Component/sellerGifts";
import { useOrderGiftItems, OrderGiftGridCells } from "../../../../Component/UI/SellerGiftList";
import OrderProductPaymentCells, { productNetAmount } from './OrderProductPaymentCells';
import OrderDeliveryCells from './OrderDeliveryCells';
import BankRefundCell from './BankRefundCell';
import OrderPaymentCells from './OrderPaymentCells';
import React, { memo, useState } from "react";
import { Order_detail, OrderListprops } from "../../../../Component/Interface/Order";
import { CheckBox } from "../../../../Component/style/common_style";
import {
  OrderCell,
  OrderHeaderCell,
  OrderTable,
  OrderTableHeader,
  RenderOrderCells,
} from "../../../../Component/style/orderTable_style2";
import styled from "styled-components";
import ExcessOrderItemModal from "../Modal/ExcessOrderItemModal";

// 헤더/바디가 같은 컬럼 순서·너비를 공유해야 정렬이 안 어긋난다 — 이 배열이 유일한 기준(SSOT).
// 취소수량 컬럼은 cancelMode일 때만 존재하므로 DOM(RenderOrderCells 유무)과 함께 항상 같이 넣고 뺀다.
const buildGridColumns = (showTracking: boolean, cancelMode?: boolean) =>
  [
    "4rem", // 체크박스
    "8rem", // 주문번호
    "8rem", // 주문상세번호
    "10rem", // 주문일시
    "10rem", // 상태변경일
    ...(showTracking ? ["10rem"] : []), // 택배 상태
    "8rem", // 주문자
    "10rem", // 입금자
    "8rem", // 상품코드
    "minmax(28rem, 3fr)", // 품목명
    "minmax(10rem, 1fr)", // 옵션
    "minmax(8rem, 1fr)", // 단가
    "6rem", // 수량
    ...(cancelMode ? ["8rem"] : []), // 취소 수량
    "8rem", // 할인 금액
    "minmax(10rem, 1fr)", // 총 금액
    "6rem", // 택배비
    "minmax(10rem, 1fr)", // 총 결제금액
    "12rem", "13rem", "12rem", "13rem", "20rem", // PG/무통장 금액과 확인일시
    "8rem", // 받는 분
    "12rem", // 받는 분 전화
    "7rem", // 받는 분 우편번호
    "minmax(20rem, 2fr)", // 받는 분 주소
    "minmax(16rem, 1.8fr)", // 배송시 요청사항
    ...(showTracking ? ["8rem", "12rem"] : []), // 택배사, 송장번호
    "minmax(14rem, 4fr)", // 메모
  ].join(" ");

const Order_paydeil = memo(
  ({
    list,
    total,
    selectOrder,
    setSelectOrder,
    modify_memo,
    select_status,
    setSelect_status,
    page,
    liveInfo,
    cancelMode,
    cancelQtyMap,
    onChangeCancelQty,
    cancelDeliveryMap,
    onToggleCancelDelivery,
    isAllCancelDeliveryChecked,
    onSetAllCancelDelivery,
    onRequestRemoveFromCancel,
    fullOrderList,
  onBankRefund,
  }: OrderListprops) => {
    const setting_check_list = (seq: number) => {
      // 취소 리뷰 모드에선 체크 해제 = "환불 리스트에서 빼기"라 바로 안 지우고 확인 모달을 띄운다.
      if (cancelMode) {
        onRequestRemoveFromCancel?.(seq);
        return;
      }
      if (select_status !== "") {
        if (
          !window.confirm("모든 주문 선택이 취소됩니다.\n취소하시겠습니까?")
        ) {
          return;
        }
        if (setSelect_status) setSelect_status("");
        return;
      }

      if (!selectOrder || !setSelectOrder) {
        return;
      }
      const copyArr = selectOrder.includes(seq)
        ? selectOrder.filter((item) => item !== seq)
        : [...selectOrder, seq];
      setSelectOrder(copyArr);
    };

    const all_check = () => {
      // 취소 리뷰 모드에선 전체선택 해제가 개별 확인 모달 없이 한 번에 다 빠지게 돼 위험하다 — 막는다.
      if (cancelMode) return;
      if (select_status !== "" && setSelect_status) return setSelect_status("");
      if (!setSelectOrder || !selectOrder) return;

      const allDetailSeqs = list.flatMap((order) =>
        order.order_details.map((detail) => detail.detail_seq)
      );

      if (isChecked_all()) {
        setSelectOrder([]);
      } else {
        setSelectOrder(allDetailSeqs);
      }
    };

    const isChecked_all = () => {
      if (select_status !== "") return true;
      if (!selectOrder || selectOrder.length === 0) return false;
      const allDetailSeqs = list.flatMap((order) =>
        order.order_details.map((detail) => detail.detail_seq)
      );
      return allDetailSeqs.length > 0 && allDetailSeqs.every((seq) => selectOrder.includes(seq));
    };
    const isChecked_item = (detail_seq: number) => {
      if (select_status !== "") return true;
      if (selectOrder?.includes(detail_seq)) return true;
      return false;
    };

    // 초과 주문건(재고 초과) 단건 팝업 — 수량 칸의 빨간 ! 아이콘 클릭 시
    const [excessDetail, setExcessDetail] = useState<Order_detail | null>(null);
    const handleExcessModal = () => setExcessDetail(null);
    const findDetail = (detail_seq: number) =>
      list
        .flatMap((order) => order.order_details)
        .find((d) => d.detail_seq === detail_seq) ?? null;

    const showTracking = !["payment-wait", "payment-done"].includes(page);
    const giftItems = useOrderGiftItems();
  const GRID_COLUMNS = buildGridColumns(showTracking, cancelMode);
    const minWidth = (cancelMode ? 337 : 329) - (showTracking ? 0 : 30);

    return (
      <>
        <OrderTableHeader $columns={GRID_COLUMNS} $minWidth={minWidth}>
          <OrderHeaderCell>
            <CheckBox
              type={"checkbox"}
              className="red"
              onChange={all_check}
              checked={isChecked_all()}
            />
          </OrderHeaderCell>
          <OrderHeaderCell>주문번호</OrderHeaderCell><OrderHeaderCell>주문상세번호</OrderHeaderCell>
        <OrderHeaderCell>주문일시</OrderHeaderCell>
          <OrderHeaderCell>상태변경일</OrderHeaderCell>
          {showTracking && <OrderHeaderCell>택배 상태</OrderHeaderCell>}
          <OrderHeaderCell>주문자</OrderHeaderCell>
          <OrderHeaderCell>입금자</OrderHeaderCell>
          <OrderHeaderCell>상품코드</OrderHeaderCell>
          <OrderHeaderCell>품목명</OrderHeaderCell>
          <OrderHeaderCell>옵션</OrderHeaderCell>
          <OrderHeaderCell>단가</OrderHeaderCell>
          <OrderHeaderCell>수량</OrderHeaderCell>
          {cancelMode && <OrderHeaderCell>취소 수량</OrderHeaderCell>}
          <OrderHeaderCell>할인 금액</OrderHeaderCell>
          <OrderHeaderCell>총 금액</OrderHeaderCell>
          <OrderHeaderCell>
            택배비
            {cancelMode && (
              <CheckBox
                type={"checkbox"}
                className="red"
                style={{ marginLeft: 4 }}
                checked={isAllCancelDeliveryChecked ?? false}
                onChange={() =>
                  onSetAllCancelDelivery?.(!isAllCancelDeliveryChecked)
                }
              />
            )}
          </OrderHeaderCell>
          <OrderHeaderCell>총 결제금액</OrderHeaderCell>
          <OrderHeaderCell>PG 결제금액</OrderHeaderCell><OrderHeaderCell>PG 결제일시</OrderHeaderCell>
          <OrderHeaderCell>무통장 입금액</OrderHeaderCell><OrderHeaderCell>무통장 입금 확인일시</OrderHeaderCell>
          <OrderHeaderCell>무통장 환불</OrderHeaderCell>
          <OrderHeaderCell>받는 분</OrderHeaderCell>
          <OrderHeaderCell>받는 분 전화</OrderHeaderCell>
          <OrderHeaderCell>받는 분 우편번호</OrderHeaderCell>
          <OrderHeaderCell>받는 분 주소</OrderHeaderCell>
          <OrderHeaderCell>배송시 요청사항</OrderHeaderCell>
          {showTracking && <>
            <OrderHeaderCell>택배사</OrderHeaderCell>
            <OrderHeaderCell>송장번호</OrderHeaderCell>
          </>}
          <OrderHeaderCell className="last">메모</OrderHeaderCell>
        </OrderTableHeader>

        {list.map((data, idx) => {
          const gifts = giftItems.filter(gift => sellerGiftSourceOrder(gift) === data.seq
            && (gift.source_product_seq == null || data.order_details.some(detail => Number(detail.product_seq) === Number(gift.source_product_seq))));
          const layout = linkedOrderRowLayout(data.order_details, gifts);
          const rowHeight = layout.rowCount;
          // 취소수량/택배비 체크를 반영한 재계산. cancelMode에선 data.order_details가 체크된
          // 것만 남은 상태라, fullOrderList에서 원본을 찾아 체크 안 된 형제 품목(안 건드리는
          // 상품)은 원금액 그대로, 체크된 품목만 (수량-취소수량)으로 남는 금액을 합산한다.
          const fullOrder = fullOrderList?.find((o) => o.seq === data.seq);
          const selectedSeqs = new Set(data.order_details.map((d) => d.detail_seq));
          const cancelTotalPayment =
            (fullOrder?.order_details ?? data.order_details).reduce((sum, d) => {
              if (selectedSeqs.has(d.detail_seq)) {
                const cancelQty = cancelQtyMap?.[d.detail_seq] ?? d.order_cnt;
                return sum + productNetAmount(d, cancelQty);
              }
              return sum + productNetAmount(d);
            }, 0) + ((cancelDeliveryMap?.[data.seq] ?? true) ? 0 : data.delivery_price);

          const total_payment = cancelMode
            ? cancelTotalPayment.toLocaleString("ko-KR")
            : (data.payment_summary ? data.payment_summary.pg_amount + data.payment_summary.bank_amount : Number(data.total_payment) + Number(data.delivery_price || 0)).toLocaleString("ko-KR");
          // 취소수량/택배비를 제외한 나머지 열은 리뷰 모드일 때 비활성화된 느낌으로 회색 처리.
          const dim = cancelMode ? ({ color: "var(--admin-theme-muted, #716a7c)" } as React.CSSProperties) : undefined;

          return (
            <OrderRowLayout.Provider key={data.seq} value={layout}><OrderTable aria-label={`주문 ${data.seq}`} 
              key={data.seq}
              className={idx % 2 === 0 ? "" : "x2"}
              $columns={GRID_COLUMNS}
              $minWidth={minWidth}
              $height={rowHeight}
            >
              <OrderGiftGridCells items={gifts} firstRow={(data.order_details.length || 1) + 1} columns={Object.fromEntries(Object.entries({
                1: 'blank', 3: 'number', 4: 'date', 5: 'blank', 8: 'product', 9: 'name', 10: 'option', 11: 'amount', 12: 'quantity',
                13: 'amount', 14: 'amount', 22: 'recipient', 23: 'phone', 24: 'postcode', 25: 'address', 27: 'memo',
              }).map(([col, value]) => [Number(col) + (showTracking && Number(col) >= 6 ? (Number(col) === 27 ? 3 : 1) : 0), value])
                .concat(showTracking ? [[6, 'blank'], [28, 'blank'], [29, 'blank']] : []).map(([col,value])=>[Number(col)+(cancelMode && Number(col)>=(showTracking ? 14 : 13)?1:0),value]).concat(cancelMode ? [[showTracking ? 14 : 13, 'blank']] : [])) as any} />
              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"seq_check"}
                renderCell={(detail_seq) => (
                  <CheckBox
                    type={"checkbox"}
                    className="red"
                    value={detail_seq}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setting_check_list(Number(e.target.value))
                    }
                    checked={isChecked_item(detail_seq)}
                  />
                )}
              />

              <OrderCell style={dim}>{data.seq}</OrderCell><RenderOrderCells detailData={data.order_details} searchkey="seq_check" cellStyle={dim} renderCell={seq => seq} />
              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"주문일시"}
                cellStyle={dim}
              />
              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"상태변경일"}
                cellStyle={dim}
              />
              {showTracking && <RenderOrderCells detailData={data.order_details} searchkey="택배 상태" cellStyle={dim} />}

              <OrderCell style={dim}><OrderAddressText address={data.order_name + (data.buyer_withdrawn ? " (탈퇴 회원)" : "")} /></OrderCell>
              <OrderCell style={dim}><OrderAddressText address={data.order_nickname || "-"} /></OrderCell>

              {["상품코드", "품목명", "옵션", "단가"].map((key) => (
                <RenderOrderCells
                  key={key}
                  detailData={data.order_details}
                  searchkey={key}
                  cellStyle={dim}
                />
              ))}

              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"수량_초과표시"}
                cellStyle={dim}
                renderCell={(detail_seq) => {
                  const detail = findDetail(detail_seq);
                  const excessQty = detail?.excess_qty ?? 0;
                  if (excessQty <= 0) return detail?.order_cnt;
                  return (
                    <ExcessQtyBtn onClick={() => setExcessDetail(detail)}>
                      {detail?.order_cnt}
                      <span className="excess">({excessQty})</span>
                      <span className="mark">!</span>
                    </ExcessQtyBtn>
                  );
                }}
              />

              {cancelMode && (
                <RenderOrderCells
                  detailData={data.order_details}
                  searchkey={"취소수량_스테퍼"}
                  renderCell={(detail_seq) => {
                    const detail = findDetail(detail_seq);
                    const max = detail?.order_cnt ?? 1;
                    const qty = cancelQtyMap?.[detail_seq] ?? max;
                    const changed = qty !== max;
                    return (
                      <CancelQtyStepper>
                        <button
                          type="button"
                          onClick={() => onChangeCancelQty?.(detail_seq, qty - 1)}
                        >
                          −
                        </button>
                        <div className={changed ? "changed" : ""}>{qty}</div>
                        <button
                          type="button"
                          onClick={() => onChangeCancelQty?.(detail_seq, qty + 1)}
                        >
                          +
                        </button>
                      </CancelQtyStepper>
                    );
                  }}
                />
              )}

              <OrderProductPaymentCells details={data.order_details} cancelQtyMap={cancelMode ? cancelQtyMap || {} : undefined} style={dim} />

              <OrderCell>
                {cancelMode ? (
                  <CancelDeliveryCell>
                    {data.delivery_price}
                    <CheckBox                      aria-label={`주문 ${data.seq} 배송비 취소`}

                      type={"checkbox"}
                      className="red"
                      checked={cancelDeliveryMap?.[data.seq] ?? true}
                      onChange={() => onToggleCancelDelivery?.(data.seq)}
                    />
                  </CancelDeliveryCell>
                ) : (
                  <div>{data.delivery_price}</div>
                )}
              </OrderCell>
              <OrderCell style={dim}>{total_payment}</OrderCell>
              <OrderPaymentCells summary={data.payment_summary} />
              <BankRefundCell order={data} onRefund={onBankRefund} />
              <OrderDeliveryCells order={data} style={dim} />
              <OrderCell style={dim}><OrderAddressText address={data.request_memo || data.order_inquiry || "-"} /></OrderCell>

              {showTracking && <>
                <RenderOrderCells
                  detailData={data.order_details}
                  searchkey={"택배사"}
                  cellStyle={dim}
                />

                <RenderOrderCells
                  detailData={data.order_details}
                  searchkey={"송장번호"}
                  cellStyle={dim}
                />
              </>}

              <RenderOrderCells
                detailData={data.order_details}
                searchkey={"seq_check"}
                className="last"
                cellStyle={dim}
                renderCell={(detail_seq) => {
                  const currentMemo =
                    data.order_details.find((d) => d.detail_seq === detail_seq)
                      ?.admin_memo || "";
                  return (
                    <MemoInput
                      defaultValue={currentMemo}
                      onMouseEnter={event => updateOverflowTitle(event.currentTarget, event.currentTarget.value)}
                      disabled={cancelMode}
                      placeholder="내용을 입력해주세요."
                      onBlur={(e) => {
                        const nextMemo = e.target.value;
                        if (nextMemo !== currentMemo && modify_memo) {
                          modify_memo(detail_seq, "admin_memo", nextMemo);
                        }
                      }}
                    />
                  );
                }}
              />

            </OrderTable></OrderRowLayout.Provider>
          );
        })}

        <ExcessOrderItemModal
          visible={excessDetail !== null}
          handleModal={handleExcessModal}
          liveInfo={liveInfo}
          excessQty={excessDetail?.excess_qty ?? 0}
        />
      </>
    );
  }
);

export default Order_paydeil;

const CancelQtyStepper = styled.div`
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px;
  border: none !important;
  button {
    width: 20px !important;
    height: 20px !important;
    flex: none !important;
    border: 1px solid var(--admin-theme-border, #e0e0e0) !important;
    border-radius: 4px;
    background: var(--admin-theme-surface, white);
    color: var(--admin-ink);
    cursor: pointer;
    line-height: 1;
    padding: 0;
  }
  div {
    width: auto !important;
    min-width: 18px;
    flex: none !important;
    border-bottom: none !important;
    text-align: center;
    font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  }
  div.changed {
    color: var(--admin-theme-danger, #eb003b);
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  }
`;

const CancelDeliveryCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const ExcessQtyBtn = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border: none !important;
  span.excess {
    color: var(--admin-theme-danger, #eb003b);
    width: auto;
    border: none !important;
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  }
  span.mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 13px;
    height: 13px;
    margin-left: 4px;
    border-radius: 50%;
    background-color: #eb003b;
    color: white;
    font-size: 9px;
    font-family: var(--font-family-base); font-weight: var(--font-weight-bold);
    flex-shrink: 0;
  }
`;

const MatchingBtn = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "matching",
}) <{ matching: boolean }>`
  width: 62px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.matching ? "linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep))" : "var(--admin-theme-raised, #F0F0F0)"};
  cursor: pointer;
  border-radius: 8px;
  color: ${(props) => (props.matching ? "white" : "var(--admin-theme-muted, #C6C6C6)")};
  font-size: 12px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;

const PayDoneBtn = styled.div`
  width: 62px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--admin-theme-accent-soft, #ecf1ff);
  cursor: pointer;
  border-radius: 8px;
  color: var(--admin-theme-link, #2768ff);
  font-size: 12px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
`;

const MemoInput = styled.input`
  min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  text-align: center;
  padding: 0 0.5rem;
  box-sizing: border-box;
  font-size: 14px;
  color: var(--admin-ink);
  outline: none;
  &:focus {
    background-color: var(--admin-theme-raised, #f0f0f0);
    border-radius: 4px;
  }
  &:disabled {
    color: var(--admin-muted);
    cursor: not-allowed;
  }
`;

